import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { ChartDataSets, ChartOptions } from 'chart.js';
import * as Chart from 'chart.js';
import { Color, Label, MultiDataSet } from 'ng2-charts';
import { EstadisticasSistemaService } from 'src/app/services/estadisticas/estadisticas-sistema.service';

const COLORES_ESTADO: { [k: number]: string } = {
  1: '#9aa3af',
  2: '#f59e0b',
  3: '#a78bfa',
  4: '#34d399',
  5: '#f87171',
  6: '#3b82f6',
  7: '#B1476A',
};

const barraDataLabels = {
  id: 'barraDataLabels',
  afterDatasetsDraw(chart: any) {
    if (!chart || chart.config.type !== 'horizontalBar') {
      return;
    }
    const ctx = chart.ctx;
    chart.data.datasets.forEach((dataset: any, di: number) => {
      const meta = chart.getDatasetMeta(di);
      if (!meta || !meta.data) {
        return;
      }
      meta.data.forEach((bar: any, i: number) => {
        const value = dataset.data[i];
        if (value === null || value === undefined || value === 0) {
          return;
        }
        const model = bar._model;
        if (!model) {
          return;
        }
        const x = model.x - 6;
        const y = model.y;
        ctx.save();
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 12px sans-serif';
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        ctx.fillText(new Intl.NumberFormat('de-DE').format(value), x, y);
        ctx.restore();
      });
    });
  },
};

let dataLabelsRegistrado = false;

@Component({
  selector: 'app-estadisticas-solicitudes-usuarios',
  templateUrl: './estadisticas-solicitudes-usuarios.component.html',
  styleUrls: ['./estadisticas-solicitudes-usuarios.component.scss'],
})
export class EstadisticasSolicitudesUsuariosComponent implements OnInit {
  isLoading = true;
  errorMsg = '';
  resumen: any = null;
  actividad: any = null;

  filtros = { fechaDesde: '', fechaHasta: '' };
  presetActivo = '';

  pageActividad = 0;
  pageSizeActividad = 10;

  busquedaActividad = '';

  progreso = 0;

  doughnutLabels: Label[] = [];
  doughnutData: MultiDataSet = [[]];
  doughnutColors: Color[] = [];
  doughnutType: ChartType = 'doughnut';

  lineLabels: Label[] = [];
  lineData: ChartDataSets[] = [];
  lineColors: Color[] = [];
  lineOptions: ChartOptions = {};
  lineType: ChartType = 'line';
  lineLegend = true;

  atencionLabels: Label[] = [];
  atencionData: ChartDataSets[] = [];
  atencionType: ChartType = 'horizontalBar';
  atencionOptions: ChartOptions = {};

  porSedeLabels: Label[] = [];
  porSedeData: ChartDataSets[] = [];
  porSedeType: ChartType = 'horizontalBar';
  porSedeOptions: ChartOptions = {};

  porPlanLabels: Label[] = [];
  porPlanData: ChartDataSets[] = [];
  porPlanColors: Color[] = [];
  porPlanType: ChartType = 'horizontalBar';
  porPlanOptions: ChartOptions = {};
  porPlanLegend = true;

  secciones: { [key: string]: boolean } = {};

  composicionLabels: Label[] = [];
  composicionData: MultiDataSet = [[]];
  composicionColors: Color[] = [];
  composicionType: ChartType = 'doughnut';

  presentadasLineLabels: Label[] = [];
  presentadasLineData: ChartDataSets[] = [];
  presentadasLineColors: Color[] = [];
  presentadasLineOptions: ChartOptions = {};
  presentadasLineType: ChartType = 'line';
  presentadasLineLegend = true;

  mostrarDesglose = false;

  constructor(private service: EstadisticasSistemaService) {}

  ngOnInit(): void {
    if (!dataLabelsRegistrado) {
      Chart.plugins.register(barraDataLabels as any);
      dataLabelsRegistrado = true;
    }
    this.aplicarPreset('ultimoMes');
  }

  async cargar(): Promise<void> {
    this.isLoading = true;
    this.errorMsg = '';
    this.pageActividad = 0;
    this.progreso = 10;
    try {
      const payload = this.payload();
      const [resumen, actividad] = await Promise.all([
        this.service.resumenSolicitudes(payload).then((r) => {
          this.progreso = Math.max(this.progreso, 75);
          return r;
        }),
        this.service.actividadUsuarios(payload).then((r) => {
          this.progreso = Math.max(this.progreso, 90);
          return r;
        }),
      ]);
      this.resumen = resumen;
      this.actividad = actividad;
      this.buildDoughnut();
      this.buildLine();
      this.buildAtencionChart();
      this.buildPorSedeChart();
      this.buildPorPlanChart();
      this.buildComposicionChart();
      this.buildPresentadasLine();
    } catch (e) {
      console.error('Error cargando estadísticas de solicitudes:', e);
      this.errorMsg =
        'No se pudieron cargar las estadísticas. Intente nuevamente.';
    } finally {
      this.progreso = 100;
      this.isLoading = false;
    }
  }

  payload(): any {
    const p: any = {};
    if (this.filtros.fechaDesde) {
      p.fechaDesde = this.inicioDeDia(this.filtros.fechaDesde).toISOString();
    }
    if (this.filtros.fechaHasta) {
      p.fechaHasta = this.finDeDia(this.filtros.fechaHasta).toISOString();
    }
    return p;
  }

  private inicioDeDia(d: string): Date {
    const [y, m, dd] = d.split('-').map(Number);
    return new Date(y, m - 1, dd, 0, 0, 0, 0);
  }

  private finDeDia(d: string): Date {
    const [y, m, dd] = d.split('-').map(Number);
    return new Date(y, m - 1, dd, 23, 59, 59, 999);
  }

  private toDateInput(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  }

  aplicarPreset(preset: string): void {
    this.presetActivo = preset;
    const hoy = new Date();
    let desde: Date;
    let hasta: Date;
    switch (preset) {
      case 'hoy':
        desde = new Date(hoy);
        hasta = new Date(hoy);
        break;
      case '7dias':
        desde = new Date(hoy);
        desde.setDate(desde.getDate() - 6);
        hasta = new Date(hoy);
        break;
      case '30dias':
        desde = new Date(hoy);
        desde.setDate(desde.getDate() - 29);
        hasta = new Date(hoy);
        break;
      case 'mes':
        desde = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        hasta = new Date(hoy);
        break;
      case 'ultimoMes':
        desde = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
        hasta = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
        break;
      case 'todos':
        desde =
          this.resumen && this.resumen.desdeDatos
            ? new Date(this.resumen.desdeDatos)
            : new Date(hoy);
        hasta = new Date(hoy);
        break;
      default:
        return;
    }
    this.filtros.fechaDesde = this.toDateInput(desde);
    this.filtros.fechaHasta = this.toDateInput(hasta);
    this.cargar();
  }

  aplicarManual(): void {
    this.presetActivo = '';
    this.cargar();
  }

  limpiar(): void {
    this.aplicarPreset('ultimoMes');
  }

  capitalizarNombre(texto: string): string {
    if (!texto) {
      return texto;
    }
    return texto
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  get actividadUsuariosFiltrados(): any[] {
    const usuarios =
      this.actividad && this.actividad.usuarios ? this.actividad.usuarios : [];
    const q = (this.busquedaActividad || '').trim().toLowerCase();
    if (!q) {
      return usuarios;
    }
    return usuarios.filter(
      (u) =>
        (u.userName || '').toLowerCase().includes(q) ||
        (u.rol || '').toLowerCase().includes(q),
    );
  }

  get actividadUsuariosPaginados(): any[] {
    const desde = this.pageActividad * this.pageSizeActividad;
    return this.actividadUsuariosFiltrados.slice(
      desde,
      desde + this.pageSizeActividad,
    );
  }

  get totalPaginasActividad(): number {
    return Math.max(
      1,
      Math.ceil(this.actividadUsuariosFiltrados.length / this.pageSizeActividad),
    );
  }

  onBusquedaActividad(): void {
    this.pageActividad = 0;
  }

  paginaActividadAnterior(): void {
    if (this.pageActividad > 0) {
      this.pageActividad = this.pageActividad - 1;
    }
  }

  paginaActividadSiguiente(): void {
    if (this.pageActividad + 1 < this.totalPaginasActividad) {
      this.pageActividad = this.pageActividad + 1;
    }
  }

  get desdeDatosTexto(): string {
    const d =
      this.resumen && this.resumen.desdeDatos
        ? new Date(this.resumen.desdeDatos)
        : null;
    if (!d || isNaN(d.getTime())) {
      return '';
    }
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
  }

  buildDoughnut(): void {
    if (!this.resumen || !this.resumen.porEstado) {
      return;
    }
    this.doughnutLabels = this.resumen.porEstado.map((e: any) => e.nombre);
    this.doughnutData = [this.resumen.porEstado.map((e: any) => e.cantidad)];
    this.doughnutColors = [
      {
        backgroundColor: this.resumen.porEstado.map(
          (e: any) => COLORES_ESTADO[e.numberState] || '#9aa3af',
        ),
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ];
  }

  buildLine(): void {
    if (!this.resumen || !this.resumen.recibidas || !this.resumen.recibidas.porDia) {
      return;
    }
    const porDia = this.resumen.recibidas.porDia;
    this.lineLabels = porDia.map((d: any) => d.fecha);
    this.lineData = [
      { data: porDia.map((d: any) => d.cantidad), label: 'Recibidas' },
    ];
    this.lineColors = [
      {
        backgroundColor: 'rgba(59,130,246,0.15)',
        borderColor: '#3b82f6',
        pointBackgroundColor: '#3b82f6',
        pointBorderColor: '#ffffff',
      },
    ];
    this.lineOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
      },
    };
  }

  buildAtencionChart(): void {
    const usuarios =
      this.actividad && this.actividad.usuarios ? this.actividad.usuarios : [];
    const top = [...usuarios]
      .sort((a: any, b: any) => b.atendidas - a.atendidas)
      .slice(0, 20);
    this.atencionLabels = top.map((u: any) => this.capitalizarNombre(u.userName) || '—');
    this.atencionData = [
      { data: top.map((u: any) => u.atendidas), label: 'Atendidas' },
    ];
    this.atencionOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        xAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
      },
    };
  }

  buildPorSedeChart(): void {
    const porSede =
      this.resumen && this.resumen.porSede ? this.resumen.porSede : [];
    this.porSedeLabels = porSede.map((s: any) => s.sede || '(Sin sede)');
    this.porSedeData = [
      { data: porSede.map((s: any) => s.cantidad), label: 'Solicitudes' },
    ];
    this.porSedeOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        xAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
      },
    };
  }

  buildPorPlanChart(): void {
    const porPlan =
      this.resumen && this.resumen.porPlan ? this.resumen.porPlan : [];
    const conPlan = porPlan.filter((p: any) => p.plan && p.plan !== 'Sin plan');
    this.porPlanLabels = conPlan.map((p: any) => p.plan);
    this.porPlanData = [
      {
        data: conPlan.map((p: any) => p.aprobadas || 0),
        label: 'Aprobadas',
      },
      {
        data: conPlan.map((p: any) => p.anuladas || 0),
        label: 'Anuladas',
      },
    ];
    this.porPlanColors = [
      {
        backgroundColor: '#34d399',
        borderColor: '#34d399',
      },
      {
        backgroundColor: '#f87171',
        borderColor: '#f87171',
      },
    ];
    this.porPlanOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: true },
      scales: {
        xAxes: [{ stacked: true, ticks: { beginAtZero: true, precision: 0 } }],
        yAxes: [{ stacked: true }],
      },
    };
  }

  toggleSeccion(key: string): void {
    this.secciones[key] = !this.secciones[key];
  }

  buildComposicionChart(): void {
    const d =
      this.resumen && this.resumen.desgloseSolicitudes
        ? this.resumen.desgloseSolicitudes
        : null;
    if (!d) {
      return;
    }
    this.composicionLabels = [
      'Solicitudes',
      'Presentadas (estado 0)',
      'Documentación presentada (estado 1)',
      'Inscripciones',
      'Inscripciones aprobadas (estado 4)',
    ];
    this.composicionData = [
      [
        d.activas,
        d.estado0,
        d.estado1,
        d.inscripciones,
        d.inscripcionesAprobadas,
      ],
    ];
    this.composicionColors = [
      {
        backgroundColor: ['#580f2e', '#9aa3af', '#3b82f6', '#f59e0b', '#a78bfa'],
        borderColor: '#ffffff',
        borderWidth: 2,
      },
    ];
  }

  buildPresentadasLine(): void {
    const porMes =
      this.resumen && this.resumen.presentadasPorMes
        ? this.resumen.presentadasPorMes
        : [];
    this.presentadasLineLabels = porMes.map((m: any) => m.mes);
    this.presentadasLineData = [
      { data: porMes.map((m: any) => m.cantidad), label: 'Presentadas (estado 0)' },
    ];
    this.presentadasLineColors = [
      {
        backgroundColor: 'rgba(154,163,175,0.15)',
        borderColor: '#9aa3af',
        pointBackgroundColor: '#9aa3af',
        pointBorderColor: '#ffffff',
      },
    ];
    this.presentadasLineOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
      },
    };
  }

  totalPorEstado(): number {
    if (!this.resumen || !this.resumen.porEstado) {
      return 0;
    }
    return this.resumen.porEstado.reduce(
      (s: number, e: any) => s + e.cantidad,
      0,
    );
  }

  totalPorSede(): number {
    const porSede =
      this.resumen && this.resumen.porSede ? this.resumen.porSede : [];
    return porSede.reduce((s: number, e: any) => s + (e.cantidad || 0), 0);
  }

  solicitudesSinSede(): number {
    const total = this.resumen ? this.resumen.totalSolicitudes || 0 : 0;
    return Math.max(0, total - this.totalPorSede());
  }

  inscripcionesValidas(): number {
    const total = this.resumen ? this.resumen.totalInscripciones || 0 : 0;
    const anuladas = this.resumen ? this.resumen.inscripcionesAnuladas || 0 : 0;
    return Math.max(0, total - anuladas);
  }

  formatoDias(v: number): string {
    if (v === null || v === undefined) {
      return '—';
    }
    return `${Math.round(v * 100) / 100} días`;
  }
}
